import { listPendingEvaluations } from 'api/admin/coach/listPendingEvaluations'

const ROOT = 'coach'

type PendingEvaluationsKeyParams = Pick<
  Parameters<typeof listPendingEvaluations>[0],
  'timeframe' | 'companyId' | 'positionId' | 'shiftId' | 'pageSize'
>

export const coachKeys = {
  all: [ROOT] as const,
  pendingEvaluations: (params?: PendingEvaluationsKeyParams) =>
    [ROOT, 'assessments', 'pendingEvaluations', params] as const,
  assessmentDetail: (positionId?: number, userId?: number) =>
    [ROOT, 'assessments', 'detail', positionId, userId] as const,
  assessmentTranscript: (transcriptUrl?: string) =>
    [ROOT, 'assessments', 'transcript', transcriptUrl] as const,
}
